import { messaging, getToken, onMessage } from './firebaseConfig';

export const requestFirebaseNotificationPermission = async () => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const currentToken = await getToken(messaging, {
      vapidKey: 'BP1SPgkL_gjAQ3M0SJhSCk2N7l3b8goBdRuvENs4eV_7GTDH_DLBnxjah343iroj0E7Ua5vaUDnwhonrOK1iAN0',
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      console.log('✅ Firebase token:', currentToken);
      return currentToken;
    } else {
      console.warn('⚠️ No registration token available.');
      return null;
    }
  } catch (err) {
    console.error('❌ Error retrieving FCM token:', err);
    return null;
  }
};

export const onFirebaseMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
